import { render } from "./exportRegister.vue?vue&type=template&id=208aefda&scoped=true"
import script from "./exportRegister.vue?vue&type=script&lang=js"
export * from "./exportRegister.vue?vue&type=script&lang=js"

import "./exportRegister.vue?vue&type=style&index=0&id=208aefda&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208aefda"],['__file',"src/views/channel/components/exportRegister.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "208aefda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('208aefda', __exports__)) {
    console.log('reload')
    api.reload('208aefda', __exports__)
  }
  
  module.hot.accept("./exportRegister.vue?vue&type=template&id=208aefda&scoped=true", () => {
    console.log('re-render')
    api.rerender('208aefda', render)
  })

}


export default __exports__